import { apiGet, apiPost, apiPostFormData, apiRequest } from '../../../apiClient';

export const listCategories = (token) => apiGet('/support/categories', token);

export const listTickets = (params, token) =>
  apiGet(`/support/tickets?${new URLSearchParams(params || {})}`, token);

export const createTicket = (data, token) => apiPost('/support/tickets', data, token);

export const getTicket = (ticketId, token) =>
  apiGet(`/support/tickets/${ticketId}`, token);

export const sendMessage = (ticketId, data, token) =>
  apiPost(`/support/tickets/${ticketId}/messages`, data, token);

export const markTicketRead = (ticketId, token) =>
  apiRequest(`/support/tickets/${ticketId}/read`, { method: 'POST', token });

export const getUnreadCount = (token) => apiGet('/support/unread-count', token);

export const uploadAttachment = (formData, token) =>
  apiPostFormData('/support/attachments', formData, token);

export const getAttachmentDownloadUrl = (attachmentId, token) =>
  apiGet(`/support/attachments/${attachmentId}/download`, token);
